import { useContext } from 'react';
import { ActiveSystemMessageContext } from './ActiveSystemMessageProvider';

export const useActiveSystemMessage = () => {
    const context = useContext(ActiveSystemMessageContext);

    if (!context) {
        throw new Error('useActiveSystemMessage must be used within ActiveSystemMessageProvider');
    }

    return context;
};
